import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import PharmaTermsAndConditions from '../../components/EnrollForm/PharmaTermsAndConditions';
import BreadCrumbs from '../../components/Breadcrumbs';
import ExternalModal from '../../components/Modals/ExternalModal';
import { withRouter } from 'react-router-dom';
import Footnotes from '../../components/Footnotes';

const TermsAndConditions = (props) => {
  let gtmTrackId = '';
  switch (props.environment) {
    case 'alunbrig':
      gtmTrackId = 'track-204 gtm-track-78';
      break;
    case 'fruzaqla':
      gtmTrackId = 'track-204 gtm-track-78';
      break;
    case 'iclusig':
      gtmTrackId = 'track-204 gtm-track-79';
      break;
    case 'ninlaro':
      gtmTrackId = 'track-204 gtm-track-80';
      break;
    case 'mimrylo':
      gtmTrackId = 'track-204 gtm-track-81';
      break;
    default:
      gtmTrackId = '';
  }

  return (
    <div className="terms-and-conditions full-width">
      <BreadCrumbs activeIndex={ 0 }/>¬
      <div className="wrapper">
        <div className="right-spacing">
          <Header as="h1">
            Enroll your patient in the Takeda Oncology Co-Pay Assistance Program
            <Header.Subheader>
                Eligible patients may pay as little as $0 for their Takeda Oncology prescription.<sup>†</sup> Please review and complete the form below with your patient to get started.
            </Header.Subheader>
          </Header>
          <p className="intro">Please be aware that the information you provide below about your patient will be used by companies working with Takeda Oncology for the purposes of evaluating and continually confirming your patient’s eligibility for the Takeda Oncology Co-Pay
          Assistance Program. In addition, Takeda Oncology, and companies working with Takeda Oncology, will have access to the patient information you provide and the information that is obtained through the use of the co-pay card during your patient’s participation in this program
          and other optional programs your patient signs up for. Please review Takeda Oncology’s privacy policy available <ExternalModal url="https://www.takeda.com/privacy-notice/" trigger={ <a className={ `track track-202 track-env-${props.environment}` } rel="noopener noreferrer">here</a> }/>.</p>
        </div>
        <PharmaTermsAndConditions
          environment={ props.environment }
          onSubmit={ props.onSubmit }
          formType={ props.formType }
          submitTrackId= { gtmTrackId }
        />
        <Footnotes footnotes={ [2, 3, 4] }/>
      </div>
    </div>
  );
};

TermsAndConditions.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  environment: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
};

export default withRouter(TermsAndConditions);
